var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsers1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 37.625c0-4.258-1.686-8.342-4.686-11.353-3-3.01-7.07-4.702-11.314-4.702a15.972 15.972 0 00-11.314 4.702A16.084 16.084 0 001.5 37.625M17.5 21.57c5.523 0 10-4.493 10-10.035S23.023 1.5 17.5 1.5s-10 4.493-10 10.035 4.477 10.034 10 10.034zM41.5 35.618c0-6.763-4-13.045-8-16.055a10.028 10.028 0 003.061-3.785 10.065 10.065 0 00-.51-9.443 10.016 10.016 0 00-3.45-3.43",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers1);
export default ForwardRef;